<template>
  <div class="rrd-page d-flex">
    <!-- LEFT SIDE BAR -->
    <PublicLeftSide/>
    <!-- RIGHT CONTENT -->
    <main class="rrd-content flex-fill d-flex flex-column p-0 ">
      <page-transition>
        <div :class="{'right-scroll': this.$router.currentRoute.name !== routeName.RN_LOGIN}">
        <router-view></router-view>
        </div>
      </page-transition>
      <AppPublicFooter/>
    </main>
  </div>
</template>

<script>
import AppPublicFooter from "@/components/app/AppPublicFooter.vue";
import PublicLeftSide from "@/containers/PublicLeftSide.vue";
import PageTransition from '@/components/app/transition/AppTransition'
import routeName from "@/router/routeNames";
export default {
  name: 'PublicContainer',
  computed: {
    routeName() {
      return routeName
    }
  },
  components: {PublicLeftSide, AppPublicFooter, PageTransition},
}
</script>

